<template>
  <div class="container" :data-testid="TEST_ID.FORO_ALTA.ROOT">
    <el-row>
      <el-col :span="24">
        <div class="title" :data-testid="TEST_ID.FORO_ALTA.TITLE">{{ $t('FORO_nuevo_post') }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="23">
        <el-card>
          <div class="card_body">
            <el-row>
                <el-col :span="24">
                  <div class="field">
                    <div class="label">{{ $t('FORO_titulo') }}</div>
                    <div :data-testid="TEST_ID.FORO_ALTA.INPUT_TITULO">
                      <el-input
                      class="input"
                      size="small"
                      v-model="post.Titulo" />
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="field">
                    <div class="label">{{ $t('FORO_descripcion') }}</div>
                    <div :data-testid="TEST_ID.FORO_ALTA.TEXTAREA_DESCRIPCION">
                      <el-input class="textarea"
                      type="textarea"
                      :rows="4"
                      v-model="post.Descripcion" />
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <div class="field">
                    <div class="label">{{ $t('FORO_imagenes') }}</div>
                    <FileUpload 
                      name="post"
                      :files="this.post.Imagenes"
                      :storeAction="'foro/updaloadImagenForo'"
                      :temporalId="idTemporal"
                      :onFileListChange="onImagenesChanged" 
                      :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                      :showPreview="true"
                      :limit="20"
                      :multiple="true"
                      :cargandoArchivo="cargando"
                      :foro="true"
                      :buttonTestId="TEST_ID.FORO_ALTA.BUTTON_UPLOAD_IMAGE"
                    ></FileUpload>            
                  </div>
                </el-col>
              </el-row>
              
              <el-row>
              <el-col :span="24">
                <div class="field">
                  <el-checkbox :data-testid="TEST_ID.FORO_ALTA.CHECKBOX_PERMITIR_IMAGENES" v-model="permitirImagenes">{{ $t('FORO_permitir_imagenes') }}</el-checkbox>
                </div>
              </el-col>
              </el-row>
              
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="btnContainer">
      <el-button :data-testid="TEST_ID.FORO_ALTA.BUTTON_GUARDAR" type="primary" @click="save" :loading="guardando" :disabled="cargaArchivo">{{ $t('GENERAL_saveBtn') }}</el-button>
      <router-link :to="{ name: 'Foro'}">
        <el-button :data-testid="TEST_ID.FORO_ALTA.BUTTON_CANCELAR">{{ $t('GENERAL_cancelBtn') }}</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
  import FileUpload from '../FileUpload/index'
  import { mapState } from 'vuex'
  import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado/index'
  import { showError, showSuccess } from '../Mensaje'
  import TEST_ID from '@/testIds.json'

  export default {
    name: 'AltaPost',
    components: { FileUpload },
    data() {
      return {
        TEST_ID,
        post: {
          Titulo: '',
          Descripcion: '',
          Imagenes: [],
          Instancia: 'B'
        },
        idTemporal: (new Date()).getTime().toString(),
        cargaArchivo: false,
        guardando: false,
        permitirImagenes: true,
      }
    },

    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
        nombreCompleto: state => state.sesion.resultadoAutenticacion.NombreCompleto
      }),
    },
    methods: {
      onImagenesChanged(name,fileUpload) {
        this.post.Imagenes = fileUpload//.map((x) => { return { name: x.value } })
      },

      save() {

        this.guardando = true

        // validaciones
        let valida = true

        if(!this.post.Titulo) {
          showError(this.$t('FORO_titulo_missing'))
          valida = false
        }

        if(!this.post.Descripcion) {
          showError(this.$t('FORO_descripcion_missing'))
          valida = false
        }

        if(!valida) {
          this.guardando = false
          return
        }

        // armo el payload
        let payload = {
          Titulo: this.post.Titulo,
          Descripcion: this.post.Descripcion,
          Imagenes: this.post.Imagenes.map((x) => { return x.name }),
          IdCarpetaTemporal: this.idTemporal,
          IdUsuario: this.idUsuario,
          NombreUsuario: this.nombreCompleto,
          Instancia: this.post.Instancia,
          PermitirImagenes: this.permitirImagenes,
        }
        //console.log(this.nombreCompleto);
        // persisto el post
        this.$store.dispatch('foro/saveEntradaForo', payload)
        .then(data => {
          if(data.CodigoResultado === 0) {
            showSuccess(this.$t('FORO_exito'))
            this.$router.push({ name: 'Foro' })
          }
          else
            mostrarMensajeInternacionalizado(data.CodigoResultado)
        })
        .finally(() => this.guardando = false)
      },

      cargando(value) {
        this.cargaArchivo = value;
      }
    }
  }

</script>

<style scoped>
  .container{
    display: inline-block;
    padding: 0 30px;
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
  }
  /* .container {
    padding: 5%;
    max-width: 920px;
  } */
  .card_body {
    padding: 5%;
  }
  .card_body {
    text-align: left;
  }
  .title {
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0 0 20px;
  padding: 0 0 7px;
  }
  .field {
    padding: 0 8px;
  }
  .label {
    font-size: 14px;
    text-align: left;
    margin: 15px 0 4px;
  }
  .input {
    box-sizing: border-box;
    display: inline-block;
    outline: 0;
  }
  .textarea {
    border-radius: 4px;
    min-height: 90px;
  }
  .imagen {
    vertical-align: top;
  }
 .btnContainer {
    margin-top: 30px;
  }

  @media(max-width: 600px) {

    .container{
     padding: 2px 5px;
    }
  }
</style>